<div class="consensus-summary-wrapper">
  <div class="split">
    <div class=" first">
      <app-rating-distribution
        [ratingDistribution]="ratingDistribution"
        [hasConsensus]="hasConsensus"
        [totalBrokers]="summary.total_no_of_broker"
        [brokerInRatingConsensus]="summary.broker_in_rating_consensus"
        [sumOfBrokerWithBuyHoldSellRating]="sumOfBrokerWithBuyHoldSellRating"
        [tprConsensusDataReady]="tprConsensusDataReady"
        [primaryTicker]="primaryTicker"
      ></app-rating-distribution>
    </div>
    <div class="section-seperator"></div>
    <div class="second">
      <app-rating-consensus
        [primaryTicker]="primaryTicker"
        [brokerInRatingConsensus]="brokerInRatingConsensus"
        [totalBroker]="totalBroker"
      ></app-rating-consensus>
    </div>
    <div class="section-seperator"></div>
    <div class=" third">
      <app-target-price-consensus
        [primaryTicker]="primaryTicker"
        [brokerInTPConsensus]="brokerInTPConsensus"
        [totalBroker]="totalBroker"
      ></app-target-price-consensus>
    </div>
  </div>
</div>
